import { render } from "./answer.vue?vue&type=template&id=cb45c55a&scoped=true&ts=true"
import script from "./answer.vue?vue&type=script&lang=ts"
export * from "./answer.vue?vue&type=script&lang=ts"

import "./answer.vue?vue&type=style&index=0&id=cb45c55a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb45c55a"]])

export default __exports__